import Correlation from './Correlation';
import './Correlation.scss';

export default Correlation;